import yup from 'config/yup';

export default yup.object().shape({
  number: yup.number().required(),
});
